import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';
import {BijbEvent} from '../../../models/bijb-event';

export class DeleteGroupAction implements Action {
  public static readonly type = 'DeleteGroupAction';

  constructor(public bijbEvent: BijbEvent, public group: Group) {
  }

  public type = DeleteGroupAction.type;
}
